import React, { useEffect, useState } from "react";
import Logo from "src/Assets/images/plateron-logo.svg";
import Flag from "src/Assets/Images/icon-flag.svg";
import { phoneFormat } from "src/Shared/Utils/MobileNumberUnits";
import WithVerifyMobileNumber from "../HOC/GenerateOtp";
import RenderOnCondition from "src/Shared/Components/RenderOnCondition";
import { NumberVerification } from "src/Assets/Images";
import CustomIcon from "src/Commons/Icons/SidebarIcons/CustomIcon";
import { isMobile } from "react-device-detect";
import { getRestaurantInfo } from "src/Shared/Utils/getRestaurant";
import { Icon } from "src/Commons/Icons/SidebarIcons";
import { domainObject } from "src/Shared/Client/PartnerInfo";

interface ComponentProps {
  mobileNumber: string;
  isError: boolean;
  verifyNumber: (e: any) => void;
  onLoadingChange: (value: boolean) => void;
  onChangeMobileNumberRefId: (value: string) => void;
  onChangeOtpRefId: (value: string) => void;
  onChangeMobile: (value: string) => void;
  currentSlide: number;
  isPWAError: boolean;
  handlePWAError?: (value: boolean) => void;
}

const MobileNumberComponent: React.FC<ComponentProps> = (props) => {
  const [isValid, setIsValid] = useState<boolean>(false);
  const [domainObjectState, setDomainObjectState] = useState<domainObject>({
    name: "",
    logo: "",
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.handlePWAError) {
      props.handlePWAError(false);
    }
    const { value } = event.target;

    if (value.replace(/[^0-9]/g, "").length < 11) {
      props.onChangeMobile(value.replace(/[^0-9]/g, ""));

      if (value.replace(/[^0-9]/g, "").length === 10) {
        setIsValid(true);
      } else {
        setIsValid(false);
      }
    }
  };

  useEffect(() => {
    let { name, logo } = getRestaurantInfo();
    setDomainObjectState({ name, logo: logo.default });
  }, []);

  const handleOnFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    const { value } = event.target;
    props.onChangeMobile(value.replace(/[^0-9]/g, ""));
  };

  const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { value } = event.target;
    props.onChangeMobile(phoneFormat(value));
  };

  return (
    <div className="auth-container__content">
      <form className="auth-container__form" onSubmit={props.verifyNumber}>
        <div
          className={`auth-container__logo ${
            isMobile ? "auth-container__logo-mobile" : ""
          }`}
        >
          <img src={domainObjectState.logo} alt="Product_Logo" />
        </div>
        <h3 className="auth-container__heading">
          Welcome to {domainObjectState.name}
        </h3>
        <h6 className="auth-container__info">
          Enter your mobile number to grow your restaurant business with us{" "}
        </h6>
        <div className="form-row">
          <label className="form-label">Mobile Number</label>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <i className="auth-container__flag-icon">
                <img src={Flag} alt="Country Flag" />
              </i>
              <span className="input-group-text ml-1">(+1)</span>
            </div>
            <input
              type="text"
              inputMode="numeric"
              className={`form-control prepend-form-control ${
                props.isError || props.isPWAError ? "is-invalid" : ""
              }`}
              name="mobileNumber"
              value={props.mobileNumber}
              onChange={handleChange}
              onFocus={handleOnFocus}
              onBlur={handleOnBlur}
            />
            <div className="is-valid">
              <span>
                {isValid && (
                  <img src={NumberVerification} alt="Number Verified" />
                )}
              </span>
            </div>
            <RenderOnCondition condition={props.isError}>
              <span className="invalid-feedback">
                Please enter valid mobile number
              </span>
            </RenderOnCondition>

            <RenderOnCondition condition={props.isPWAError}>
              <span className="invalid-feedback">
                This account does not exist. Use your laptop or desktop computer
                to create a new account
              </span>
            </RenderOnCondition>
          </div>
        </div>
        <div className="auth-container__action">
          <a
            href="#"
            onClick={props.verifyNumber}
            type={"submit"}
            className="btn btn-primary btn-block btn-block--medium"
          >
            Continue
          </a>
        </div>
        <div className="auth-container__secure text-center">
          <svg
            className="mr-1"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              fill="#8692A6"
              fillRule="evenodd"
              d="M17 8.5h1c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-10c0-1.1.9-2 2-2h1v-2c0-2.76 2.24-5 5-5s5 2.24 5 5v2zm-5-5c-1.66 0-3 1.34-3 3v2h6v-2c0-1.66-1.34-3-3-3zm-6 17v-10h12v10H6zm8-5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"
              clipRule="evenodd"
            />
          </svg>
          Your information is safe with us{" "}
          <span className="bfs-angle-down"></span>
          <CustomIcon name={"bell"} size="xsm" color={"success"} />
          <CustomIcon name={"bell"} size="sm" color={"warning"} />
          <CustomIcon name={"bell"} size="md" color={"primary"} />
          <CustomIcon name={"bell"} size="lg" color={"success"} />
          <CustomIcon name={"bell"} size="xlg" color={"error"} />
        </div>
        <div className="auth-container__secure text-center">
          <RenderOnCondition
            condition={domainObjectState.name.toLocaleLowerCase() !== "nova"}
          >
            powered by{" "}
            <span className="ml-1">
              <Icon name="nova-expaned-logo" />
            </span>
          </RenderOnCondition>
        </div>
      </form>
    </div>
  );
};

export default WithVerifyMobileNumber()(MobileNumberComponent);
